<template>
  <div>
    <div
      class="purchaseOrder"
      ref="purchaseOrder"
      v-if="!noOrders"
    >
      <van-row
        class="datetimepicker"
        v-if="type != 0 && type != 5 && isShare == 0"
      >
        <van-row
          span="24"
          class="editor"
        >
          <van-col span="5">开始时间</van-col>
          <van-col
            span="19"
            class="start"
            @click="showPopup(0)"
          >
            <van-icon name="clock-o" />
            <span class="text">{{startTime}}</span>
          </van-col>
        </van-row>
        <van-row
          span="24"
          class="editor"
        >
          <van-col span="5">结束时间</van-col>
          <van-col
            span="12"
            class="start"
            @click="showPopup(1)"
          >
            <van-icon name="clock-o" />
            <span class="text">{{endTime}}</span>
          </van-col>
          <van-col span="4">
            <van-button
              type="info"
              class="searchBtn"
              @click="searchOrder"
            >搜索</van-button>
          </van-col>
        </van-row>
      </van-row>
      <div
        class="line"
        v-if="type != 0 && type != 5 && isShare == 0"
      ></div>
      <div
        class="timeRange"
        v-if="type != 0 && type != 5 && isShare == 1"
      >
        时间范围: {{startTime}} 至 {{endTime}}
      </div>
      <seller-table
        :goodsTable="goodsTable"
        :schoolTable="schoolTable"
        :type="type"
      ></seller-table>
    </div>
    <div
      class="notHave"
      v-else
    >
      <img
        src="../../assets/img/pic_noOrders.png"
        alt=""
      >
      <p>链接已失效，需要商家重新进行分享</p>
    </div>
    <van-popup
      v-model="showTime"
      class="popup"
      position="bottom"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择完整时间"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirm"
        @cancel="showTime = false"
        v-if="showTime"
      />
    </van-popup>
  </div>
</template>

<script>
import { zoomElement } from '@/utils/myTouch.js';
import sellerTable from "@/components/table/table";
import {
  getWaitCutPurchaseOrder, getWaitDeliveryTimerProduct, getAgentWaitDeliveryTimerProduct, getCountryWaitDeliveryTimerProduct, getShipWaitDeliveryTimerProduct,
  getWaitDeliveryPurchaseOrder, getSendWaitDeliveryPurchaseOrder, getSchoolWaitCutPurchaseOrder, getCountryPurchase, getWaitDeliveryTimer, getAgentWaitDeliveryTimer,
  getCountryWaitDeliveryTimer, getShipWaitDeliveryTimer, getWaitDeliveryPurchaseTimer, getSendWaitDeliveryPurchaseTimer, getCountryPurchaseTimer
} from "@/api/join";
export default {
  components: {
    sellerTable,
  },
  data() {
    return {
      timeType: 0, // 0、开始时间 1、结束时间
      startTime: "", // 开始时间展示用（时间格式化过）
      endTime: "", // 结束时间展示用（时间格式化过）
      startTimeDate: "", // 开始时间（未格式化）
      endTimeDate: "", // 结束时间（未格式化）
      showTime: false,
      minDate: new Date(1997, 0, 1),
      maxDate: "",
      currentDate: new Date(),
      goodsTable: {
        headerList: [
          {
            colWidth: "0.96rem",
            title: "序号"
          }, {
            colWidth: "3.81333rem",
            title: "商品名"
          }, {
            colWidth: "3.81333rem",
            title: "规格"
          }, {
            colWidth: "1.92rem",
            title: "份数"
          }, {
            colWidth: "2.4rem",
            title: "结算价(合计)"
          }, {
            colWidth: "1.92rem",
            title: "总量"
          }, {
            colWidth: "1.92rem",
            title: "备注"
          }
        ],
        contentList: []
      },
      schoolTable: {
        headerList: [
          {
            colWidth: "0.96rem",
            title: "序号"
          }, {
            colWidth: "3.81333rem",
            title: "学校名称"
          }, {
            colWidth: "3.81333rem",
            title: "商品名称"
          }, {
            colWidth: "1.92rem",
            title: "总量"
          }, {
            colWidth: "1.92rem",
            title: "备注"
          }
        ],
        contentList: []
      },
      type: 0,
      isShare: 0,
      noOrders: false
    };
  },
  methods: {
    searchOrder() {
      let requieName;
      // 社区待发货 1.同城销售、2.同城代发、3.全国包邮、4.立即送出
      // 校区待发货 6.全国包邮、7.立即送出
      // 校区预售待发货 8.全国包邮
      switch (this.type) {
        case "1":
          requieName = getWaitDeliveryTimerProduct
          break;
        case "2":
          requieName = getAgentWaitDeliveryTimerProduct
          break;
        case "3":
          requieName = getCountryWaitDeliveryTimerProduct
          break;
        case "4":
          requieName = getShipWaitDeliveryTimerProduct
          break;
        case "6":
          requieName = getWaitDeliveryPurchaseOrder
          break;
        case "7":
          requieName = getSendWaitDeliveryPurchaseOrder
          break;
        case "8":
          requieName = getCountryPurchase
          break;
      }
      requieName({
        startDate: this.startTime,
        endDate: this.endTime
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.goodsTable.contentList = res.content.list || res.content.productInfo;
          let csInfo = res.content.csInfo || [];
          csInfo.forEach((item, index) => item.index = index);
          this.schoolTable.contentList = csInfo;
        } else if (res.appStatus.errorCode == 4016) {
          this.noOrders = true
        }
      });
    },
    showPopup(type) {
      this.timeType = type;
      this.maxDate = new Date();
      this.minDate = new Date(1997, 0, 1);
      if (type == 0) {
        if (this.startTimeDate) {
          this.currentDate = this.startTimeDate;
        }
        if (this.endTimeDate) {
          this.maxDate = this.endTimeDate;
          this.minDate = new Date(1997, 0, 1);
        }
      }
      if (type == 1) {
        if (this.endTimeDate) {
          this.currentDate = this.endTimeDate;
        }
        if (this.startTimeDate) {
          this.minDate = this.startTimeDate;
          this.maxDate = new Date();
        }
      }
      this.showTime = true;
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      } else if (type === 'hour') {
        return `${val}时`;
      } else if (type === 'minute') {
        return `${val}分`;
      }
      return val;
    },
    confirm(val) {
      let year = val.getFullYear()
      let month = val.getMonth() + 1
      let day = val.getDate()
      let hour = val.getHours()
      let minute = val.getMinutes()
      if (month >= 1 && month <= 9) { month = `0${month}` }
      if (day >= 1 && day <= 9) { day = `0${day}` }
      if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
      if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
      let timeValue = `${year}-${month}-${day} ${hour}:${minute}`
      this.timeType == 0 ? this.startTime = timeValue : this.endTime = timeValue;
      this.timeType == 0 ? this.startTimeDate = val : this.endTimeDate = val;
      this.showTime = false;
    },
    isShareWay(type) {
      let requieName;
      // 社区待发货 1.同城销售、2.同城代发、3.全国包邮、4.立即发货
      // 校区待发货 6.全国包邮、7.立即送出
      // 校区预售待发货 8.全国包邮
      switch (type) {
        case "1":
          requieName = getWaitDeliveryTimer
          break;
        case "2":
          requieName = getAgentWaitDeliveryTimer
          break;
        case "3":
          requieName = getCountryWaitDeliveryTimer
          break;
        case "4":
          requieName = getShipWaitDeliveryTimer
          break;
        case "6":
          requieName = getWaitDeliveryPurchaseTimer
          break;
        case "7":
          requieName = getSendWaitDeliveryPurchaseTimer
          break;
        case "8":
          requieName = getCountryPurchaseTimer
          break;
      }
      requieName({}).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.startTime = res.content.startDate;
          this.startTimeDate = new Date(res.content.startDate);
          this.endTime = res.content.endDate;
          this.endTimeDate = new Date(res.content.endDate);
          this.searchOrder();
        } else if (res.appStatus.errorCode == 4016) {
          this.noOrders = true
        }
      });
    },
  },
  created() {
    // isShare 0.不是通过分享链接进入 1.是通过分享链接进入
    this.isShare = this.GetQueryString("isShare") || "0";
    this.type = this.GetQueryString("type") || "0";
    let requieName;
    // 0.社区待截单、5.校区待截单
    switch (this.type) {
      case "0":
        requieName = getWaitCutPurchaseOrder
        this.goodsTable.headerList.splice(-2, 2)
        break;
      case "5":
        requieName = getSchoolWaitCutPurchaseOrder
        break;
    }
    if (this.type == 0 || this.type == 5) {
      requieName({}).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.goodsTable.contentList = res.content.productInfo || res.content;
          let csInfo = res.content.csInfo || [];
          csInfo.forEach((item, index) => item.index = index);
          this.schoolTable.contentList = csInfo;
        } else if (res.appStatus.errorCode == 4016) {
          this.noOrders = true
        }
      })
      return false;
    }
    this.isShareWay(this.type)
  },
  mounted() {
    let zoomEl = this.$refs.purchaseOrder;
    zoomElement(zoomEl);
  }
}
</script>

<style lang="scss" scoped>
.purchaseOrder {
  transform-origin: 0 0;
}
.timeRange {
  padding: 15px 10px 0 10px;
  font-size: 12px;
  font-weight: bold;
}
.datetimepicker {
  padding: 15px;
  font-size: 15px;
  background-color: #ffffff;
  .editor {
    height: 40px;
    display: flex;
    align-items: center;
    &:last-child {
      margin-top: 10px;
    }
  }
  .start {
    display: flex;
    align-items: center;
    padding: 0 10px;
    height: 40px;
    line-height: 40px;
    background-color: #f5f5f5;
    .text {
      margin-left: 5px;
    }
  }
  .searchBtn {
    width: 90px;
    height: 35px;
    margin-left: 10px;
  }
}
.line {
  width: 100%;
  height: 10px;
  background-color: #f5f5f5;
}
.popup {
  width: 100%;
}
.notHave {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 200px;
    height: 200px;
  }
  p {
    font-size: 15px;
    color: #666666;
  }
}
</style>